import $ from 'jquery';
import EdeeshopPopup from 'fg-frontend/plugins/edeeshop-popup/EdeeshopPopup';

// export to window
window.$ = $;
window.jQuery = $;

/**
 * Edeeshop Popup init
 */
window.edeeshopPopup = new EdeeshopPopup();



// WEBPACK FOOTER //
// ./fe/web-bn/src/js/windowExports.js